import React, { useState, useEffect, useContext } from "react";
import SubsidiaryDepartmentReadOnlyRow from "./SubsidiaryDepartmentReadOnlyRow";
import SubsidiaryDepartmentTableRow from "./SubsidiaryDepartmentTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function SubsidiaryDepartmentTable({ key, setSubsidiaryDepartment, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isSubsidiaryDepartmentLoading, setIsSubsidiaryDepartmentLoading] = useState(false);
	const [isUserSubsidiaryLoading, setIsUserSubsidiaryLoading] = useState(false);
	const [subsidiaryDepartments, setSubsidiaryDepartments] = useState([]);
	const [userSubsidiaries, setUserSubsidiaries] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		departmentKey: 0,
		subsidiaryCompanyId: 0,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchUserSubsidiaries();
		fetchSubsidiaryDepartments();
	}, []);

	const handleClose = (event) => {
		setSubsidiaryDepartment(false);
	};

	function fetchUserSubsidiaries() {
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}

		setIsUserSubsidiaryLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: true,
				companyId: initialValues.companyId,
				loginId: initialValues.loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetSubsidiariesForUser", "/Service/UserService/GetSubsidiariesForUser", requestOptions, retrieveUserSubsidiarySuccess, retrieveUserSubsidiaryFail);
		} catch (error) {
			setIsUserSubsidiaryLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserSubsidiaryFail(redirect) {
		setIsUserSubsidiaryLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userGetSubsidiaryFailed"));
	}

	function retrieveUserSubsidiarySuccess(responseData) {
		let getSubsidiariesForUserResponse;
		if (responseData) {
			getSubsidiariesForUserResponse = responseData.getSubsidiariesForUserResponse;
			if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "0") {
				setUserSubsidiaries(getSubsidiariesForUserResponse.subsidiaryList.slice())
			} else if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getSubsidiariesForUserResponse) {
				setError(t("error.error") + " " + getSubsidiariesForUserResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserSubsidiaryLoading(false);
	}
	function fetchSubsidiaryDepartments() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsSubsidiaryDepartmentLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserSubsidiaryDepartment", "/Service/PartnerSubsService/GetUserSubsidiaryDepartment", requestOptions, retrieveSubsidiaryDepartmentSuccess, retrieveSubsidiaryDepartmentFail);
		} catch (error) {
			setIsSubsidiaryDepartmentLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveSubsidiaryDepartmentFail(redirect) {
		setIsSubsidiaryDepartmentLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.subsidiaryGetDepartmentFailed"));
	}

	function retrieveSubsidiaryDepartmentSuccess(responseData) {
		let fetchUserSubsDepartmentsResponse;
		if (responseData) {
			fetchUserSubsDepartmentsResponse = responseData.fetchUserSubsDepartmentsResponse;
			if (fetchUserSubsDepartmentsResponse && fetchUserSubsDepartmentsResponse.errorCode === "0") {
				setSubsidiaryDepartments(fetchUserSubsDepartmentsResponse.departments.slice())
			} else if (fetchUserSubsDepartmentsResponse && fetchUserSubsDepartmentsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserSubsDepartmentsResponse) {
				setError(t("error.error") + " " + fetchUserSubsDepartmentsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsSubsidiaryDepartmentLoading(false);
	}
	const handleDeleteClick = (event, subsidiaryDeptItem, completeCallback) => {
		event.preventDefault();
		deleteSubsidiaryDepartment(subsidiaryDeptItem, completeCallback);
	};
	const deleteSubsidiaryDepartment = (subsidiaryDeptItem, completeCallback) => {
		let action = 3;
		if (subsidiaryDeptItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			departmentKey: subsidiaryDeptItem.departmentKey,
			subsidiaryCompanyId: subsidiaryDeptItem.subsidiaryCompanyId,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserSubsidiaryDepartment", "/Service/PartnerSubsService/DeleteUserSubsidiaryDepartment", requestOptions, deleteSubsidiaryDepartmentSuccess, deleteSubsidiaryDepartmentFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteSubsidiaryDepartmentFail(redirect, completeCallback) {
		setError(t("error.userDeptEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteSubsidiaryDepartmentSuccess(responseData, completeCallback) {
		let deleteUserSubsDepartmentResponse;
		if (responseData) {
			deleteUserSubsDepartmentResponse = responseData.deleteUserSubsDepartmentResponse;
			if (deleteUserSubsDepartmentResponse) {
				if (deleteUserSubsDepartmentResponse.errorCode === "0") {
					resetRowTable();
					refreshSubsidiaryDepartment();
				} else {
					setError(t("error.error") + " " +
						deleteUserSubsDepartmentResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (subsidiaryDepartments.length > 0) {
				subsidiaryDepartments.map((subsidiaryDeptItem, index) => {
					if (subsidiaryDeptItem.departmentKey === setValues.departmentKey && subsidiaryDeptItem.subsidiaryCompanyId === setValues.subsidiaryCompanyId) {
						setError(t("error.userDeptDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveSubsidiaryDepartment(action, setValues, completeCallback);
			}
		}
	};
	const saveSubsidiaryDepartment = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			departmentKey: setValues.departmentKey,
			subsidiaryCompanyId: setValues.subsidiaryCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserSubsidiaryDepartment", "/Service/PartnerSubsService/AddUpdateUserSubsidiaryDepartment", requestOptions, saveSubsidiaryDepartmentSuccess, saveSubsidiaryDepartmentFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveSubsidiaryDepartmentFail(redirect, completeCallback) {
		setError(t("error.userDeptEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveSubsidiaryDepartmentSuccess(responseData, completeCallback) {
		let addUpdateUserSubsDepartmentResponse;
		if (responseData) {
			addUpdateUserSubsDepartmentResponse = responseData.addUpdateUserSubsDepartmentResponse;
			if (addUpdateUserSubsDepartmentResponse) {
				if (addUpdateUserSubsDepartmentResponse.errorCode === "0") {
					resetRowTable();
					refreshSubsidiaryDepartment();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserSubsDepartmentResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshSubsidiaryDepartment() {
		fetchSubsidiaryDepartments();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isSubsidiaryDepartmentLoading || isUserSubsidiaryLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.dept.name")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th">
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<SubsidiaryDepartmentTableRow
											index={count}
											userSubsidiaries={userSubsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((subsidiaryDepartments.length % 2) > 0) ? true : false} />
									}
									{(subsidiaryDepartments.length > 0) ? (
										subsidiaryDepartments.map((subsidiaryDeptItem, index) => (
											<SubsidiaryDepartmentReadOnlyRow
												index={count}
												t={t}
												subsidiaryDeptItem={subsidiaryDeptItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												setError={setError}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<SubsidiaryDepartmentTableRow
											index={count}
											userSubsidiaries={userSubsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((subsidiaryDepartments.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(subsidiaryDepartments.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.dept.name")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th">
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-close"
									id="edit-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default SubsidiaryDepartmentTable;